import { HttpClient } from '@angular/common/http';
import { APP_INITIALIZER, Inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { serviceConstants } from '../constants/service.constants';
import { ThemeModel } from '../models/theme-model';

import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from './user.service';


@Injectable({
  providedIn: 'root'
})
export class AppPreSetupService {
  themeInfo:ThemeModel={
    BUTTON_BORDER_COLOR:"",
    BUTTON_HOVER_COLOR:"",
    BUTTON_TEXT_COLOR:"",
    HEADER_COLOR:"",
    NAV_HOVER_BG:"",
    LOGIN_BUTTON_COLOR:"",
    LOGIN_BG_COLOR:"",
    LOGIN_BUTTON_HOVER:"",
    LOGIN_BTN_TEXT_COLOR:"",
    IS_ACTIVE_THEME:""
  };

 InitBaseUrl:string="";
  orgCode: string="";
  path: string;
  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string,
    private route: ActivatedRoute,
    private userService: UserService) {
    if (baseUrl != null && baseUrl.indexOf("localhost") > -1) {
      this.InitBaseUrl = serviceConstants.apiURL;

    }
    else{
        this.InitBaseUrl=baseUrl;

    }

    this.orgCode = this.userService.getOrgCode();
    if (this.orgCode == "" || this.orgCode == null || this.orgCode == undefined) {
      this.path = window.location.pathname;
      if (this.path != undefined && this.path != null && this.path.match("/login")) {
        const segments = this.path.split('/').filter(Boolean);
        if (segments.length >= 2 && segments[1] === 'login')
          this.orgCode = segments[0];
      }
    }

  }

  load() {
    return new Promise((resolve, reject) => {

       this._http.get(this.InitBaseUrl+'api/Login/GetConfigData?orgCode='+this.orgCode).subscribe({
       next: (response:any) => {

          serviceConstants.apiURL = response.Data.apiURL;
          serviceConstants.baseUrl = response.Data.baseUrl;
          serviceConstants.AdobeViewerClientID = response.Data.AdobeViewerClientID;
          serviceConstants.RequestEncription = response.Data.RequestEncription;
          if (response.Data.Themes != null) {
            this.themeInfo.BUTTON_BORDER_COLOR = response.Data.Themes.BUTTON_BORDER_COLOR;
            this.themeInfo.BUTTON_HOVER_COLOR = response.Data.Themes.BUTTON_HOVER_COLOR;
            this.themeInfo.BUTTON_TEXT_COLOR = response.Data.Themes.BUTTON_TEXT_COLOR;
            this.themeInfo.HEADER_COLOR = response.Data.Themes.HEADER_COLOR;
            this.themeInfo.NAV_HOVER_BG = response.Data.Themes.NAV_HOVER_BG;
            this.themeInfo.LOGIN_BUTTON_COLOR = response.Data.Themes.LOGIN_BUTTON_COLOR;
            this.themeInfo.LOGIN_BG_COLOR = response.Data.Themes.LOGIN_BG_COLOR;
            this.themeInfo.LOGIN_BUTTON_HOVER = response.Data.Themes.LOGIN_BUTTON_HOVER;
            this.themeInfo.LOGIN_BTN_TEXT_COLOR = response.Data.Themes.LOGIN_BTN_TEXT_COLOR;
            this.applyTheme();
          }


          resolve(true);
        },
        error:(error) => {
          console.error(error);
          throw (error.json().error || 'Server error')
          //return Observable.throw(error.json().error || 'Server error');
        }
      });
    });

  }

  applyTheme() {
    document.documentElement.style.setProperty('--header_color', this.themeInfo.HEADER_COLOR);
    document.documentElement.style.setProperty('--nav_hover_bg', this.themeInfo.NAV_HOVER_BG);
    document.documentElement.style.setProperty('--button_border-Color', this.themeInfo.BUTTON_BORDER_COLOR);
    document.documentElement.style.setProperty('--button_hover_color', this.themeInfo.BUTTON_HOVER_COLOR);
    document.documentElement.style.setProperty('--button_text_color', this.themeInfo.BUTTON_TEXT_COLOR);
    document.documentElement.style.setProperty('--login_bg_color', this.themeInfo.LOGIN_BG_COLOR);
    document.documentElement.style.setProperty('--login_button_color', this.themeInfo.LOGIN_BUTTON_COLOR);
    document.documentElement.style.setProperty('--login_button_hover', this.themeInfo.LOGIN_BUTTON_HOVER);
    document.documentElement.style.setProperty('--login_btn_text_color', this.themeInfo.LOGIN_BTN_TEXT_COLOR);
  }

}
export function AppPreSetupFactory(preService: AppPreSetupService) {
  return () => preService.load();
}

export function init() {
  return {
    provide: APP_INITIALIZER,
    useFactory: AppPreSetupFactory,
    deps: [AppPreSetupService],
    multi: true
  }
}

const AppPreSetupModule = {
  init: init
}

export { AppPreSetupModule };
